export function showLoadingDialog() {
  const dialog = PF("portalLoadingDialog");
  if (dialog instanceof PrimeFaces.widget.Dialog) {
    dialog.show();
  }
}

export function hideLoadingDialog() {
  const dialog = PF("portalLoadingDialog");
  if (dialog instanceof PrimeFaces.widget.Dialog) {
    dialog.hide();
  }
}
